import { render, staticRenderFns } from "./CustomerServiceBtn.vue?vue&type=template&id=2c1f1b06&scoped=true"
import script from "./CustomerServiceBtn.vue?vue&type=script&lang=js"
export * from "./CustomerServiceBtn.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceBtn.vue?vue&type=style&index=0&id=2c1f1b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f1b06",
  null
  
)

export default component.exports